import {Box} from '@indoqa/style-system'
import {IStyle} from 'fela'
import * as React from 'react'
import {useFela} from 'react-fela'
import {Theme} from '../../../app/theme'

interface Props {
  bookTitleOnly: boolean
  onBookTitleOnly: (checked: boolean) => void
}

export function ArTypeFilter({bookTitleOnly, onBookTitleOnly}: Props) {
  const {theme, css} = useFela<Theme>()
  const inputStyle: IStyle = {
    marginRight: theme.spacing.space1_5,
    display: 'none',
  }
  return (
    <Box>
      <Box fontSize="small" display="none">
        <label>
          <input
            className={css(inputStyle)}
            type="checkbox"
            checked={bookTitleOnly}
            onChange={(e) => onBookTitleOnly(e.target.checked)}
          />
          Nur Buchtitel anzeigen
        </label>
      </Box>
    </Box>
  )
}
